export default __webpack_public_path__ + "static/media/math-fill-in-the-blank.50499ec6.svg";